import React from 'react';
import NeighborhoodsList from './list';
import NeighborhoodsCreate from './create';
import NeighborhoodsEdit from './edit';

const NeighborhoodTitle = ({ record }) => {
    return <span>Editando el barrio {record ? `${record.name}` : ''}</span>;
};

export {NeighborhoodsList, NeighborhoodsCreate, NeighborhoodTitle, NeighborhoodsEdit};